import { StandardEvents } from '@shopify/events';

// Native forms, cart endpoints, errors and drawer focus remain Shopify-owned.
const pending = new WeakSet();
document.addEventListener('submit', event => {
  const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
  if (!form || !pending.has(form)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
  if (event.action !== 'add' || !event.promise) return;
  const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
  if (form) {
    pending.add(form);
    form.setAttribute('aria-busy', 'true');
  }
  try {
    const result = await event.promise;
    if (!result?.cart || result.detail?.didError) return;
    for (const button of form?.querySelectorAll('add-to-cart-component') || []) button.animateAddToCart?.();
    const icon = document.querySelector('.header-actions__cart-icon');
    if (icon && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      icon.animate([{transform:'scale(1)'},{transform:'scale(1.12)'},{transform:'scale(1)'}], {duration:320,easing:'ease-out'});
    }
  } catch {
    // The native form owns the visible error and its live-region announcement.
  } finally {
    if (form) {
      pending.delete(form);
      form.removeAttribute('aria-busy');
    }
  }
});
